import React from 'react'
import Slider from 'react-slick'

const SubPacks = () => (
  <div className="margin" style={{marginBottom: '10em'}}>
    <h2>Subscriber Packs</h2>
    <div className='packs'>
        <div>
        <a href="https://support.4zzz.org.au/subscriptions/passionate" target="_blank">
          <h3>Passionate Pack</h3>
          <img src="/assets/2024-passionate.jpg" />
          <p>Passionate Sub pack featuring a limited edition tee and tote bag by artist George Levi.</p>
          </a>
        </div>
        <div>
        <a href="https://support.4zzz.org.au/subscriptions/household" target="_blank">
          <h3>Household Pack</h3>
          <img src="/assets/2024-household.jpg" />
          <p>Household Sub pack including a limited edition tote bag, plus a tea towel, 2 stubby coolers, 4 pack 4zzz coasters, and a bottle opener!</p>
          </a>
        </div>
        <div>
          <a href="https://support.4zzz.org.au/subscriptions/super" target="_blank">
          <h3>SUPER SUB Pack</h3>
          <img src="/assets/2024-supersub.jpg" />
          <p>Super Sub pack featuring a limited edition tee and tote by artist George Levi, a collectable 4ZZZ pin, plus your name on our Wall of Super Subs at the station</p>
          </a>
        </div>
        <div>
          <a href="https://support.4zzz.org.au/subscriptions/super" target="_blank">
          <h3>SUPER SUB PIN!</h3>
          <img src="/assets/2024-supersub-pin.jpg" />
          <p>Detail of our yearly collectable pin only available to our supersubs.</p>
          </a>
        </div>
    </div>
  </div>
)

export default SubPacks
